import { combineReducers } from '@reduxjs/toolkit';

import { asiteReducer } from './features/asite';

// Global
import { ducks as navigationDucks } from '../../navigation';
import { ducks as usersDucks } from '../../users';

// Modules
import { smoelenboekReducer } from '../../Smoelenboek';
import { asiteRelaticsSyncLogsReducer } from '../../asite-relatics';
import { productReservationReducer } from '../../ProductReservation';
import { fastdraftRelaticsSyncLogsReducer } from '../../fastdraft-relatics';

const rootReducer = combineReducers({
    // stil to separate
    asite: asiteReducer,
    // These are truly global and used everywhere
    user: usersDucks.user.userReducer,
    navbar: navigationDucks.navbar.navbarReducer,
    // These are only on modules
    smoelenboek: smoelenboekReducer,
    asiteRelaticsSyncLogs: asiteRelaticsSyncLogsReducer,
    fastdraftRelaticsSyncLogs: fastdraftRelaticsSyncLogsReducer,
    productReservation: productReservationReducer,
});

export default rootReducer;
